<template>
    <v-app>
        <v-container fluid>
            <v-row id="report" class="ddblack" >
                <v-col cols="12" class="py-6" v-if="this.clinic">
                    <span class="d-block py-6 pb-1 text-h5">Data report for: {{ this.clinic }}</span>
                    <span class="d-block py-1 text-subtitle-1 ddgrey--text">Data shown for {{ reportDate }}</span>
                </v-col>
                <v-col cols="12">
                    <ChatsPercentages :chatsData="data.stats" :loading="loading" :reportMode="reportMode"/>
                </v-col>
                <v-col cols="12" align="center" justify="center" >
                    <MostCommonlyQuestion :chatsData="data.mostCommonlyQuestion" :loading="loading" :reportMode="reportMode"/>
                </v-col>
                <v-col cols="12">
                    <ChatsStats :chatsData="data.chats" :loading="loading" :reportMode="reportMode"/>
                </v-col>
                <v-col cols="12"  md="6">
                    <ExistingVsNewOnes :chatsData="data.existingVsNewOnes" :loading="loading" :reportMode="reportMode"/>
                </v-col>
                <v-col cols="12" md="6">
                    <ChatsByDevice :chatsData="data.devices" :loading="loading" :reportMode="reportMode"/>
                </v-col>
                <v-col cols="12" md="6">
                    <TopQuestions :chatsData="data.questions" :loading="loading" :reportMode="reportMode"/>
                </v-col>
                <v-col cols="12" md="6">
                    <TopLocations :chatsData="data.locations" :loading="loading" :defaultMapView="false" :hideControls="true" :reportMode="reportMode"/>
                </v-col>
            </v-row>
            <div id="loaded-hint" class="text-center mt-5 mb-4 ddgrey--text" v-show="!loading">Generated by DearDoc</div>
        </v-container>
    </v-app>
</template>

<script>
import DataAPI from '@/utils/DataAPI';

import ChatsStats from '@/components/dashboard/widgets/ChatsStats';
import ExistingVsNewOnes from '@/components/dashboard/widgets/ExistingVsNewOnes';
import ChatsPercentages from '@/components/dashboard/widgets/ChatsPercentages';
import TopQuestions from '@/components/dashboard/widgets/TopQuestions';
import TopLocations from '@/components/dashboard/widgets/TopLocations';
import ChatsByDevice from '@/components/dashboard/widgets/ChatsByDevice';
import MostCommonlyQuestion from '@/components/dashboard/widgets/MostCommonlyQuestion';

/**
 * This component includes all the features of Dashboard page such as change
 * between clinics, dates, download the report and show all other dashboard 
 * widgets.
 *
 * To get data from the backend it uses the class API. To ensure that the 
 * user is logged and check its capabilities it uses the class AuthAPI.
 */

export default {
    name: 'report',
    data: () => ({
        rawData: {},
        loading: true,
        clinic: "",
        data: {
            chats: {},
            existingVsNewOnes: {},
            stats: {},
            questions: {},
            locations: {
                locations: [],
                topLocations: []
            },
            devices: {},
            mostCommonlyQuestion: ''
        },
        isMobile: false,
        reportMode: null
    }),
    computed: {
        reportDate() {
            const monthNames = ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"];
            const d = new Date();
            return `${monthNames[d.getMonth()]}, ${d.getFullYear()}`;
        }
    },
    async mounted() {
        const { clinic, apiKey, frecuency, accumulated } = this.$route.query;

        this.setReportMode(frecuency, accumulated);
        await this.updateData(clinic, apiKey, frecuency, accumulated);
    },
    methods: {
        setReportMode(frecuency, cumulative) {
            this.reportMode = cumulative === 'true' ? 'cumulative' : (frecuency !== '' ? frecuency : null);
        },
        calcDateRange() {
            const { locale } = this.$i18n;
            if (this.reportMode === 'daily') {
                const yesterday = new Date();
                yesterday.setDate(yesterday.getDate() - 1);

                const [ from, to ] = [ new Date(yesterday), new Date(yesterday) ];
                from.setHours(0, 0, 0);
                to.setHours(23, 59, 59);
                return [ from.toLocaleString(locale), to.toLocaleString(locale) ];
            } else if (this.reportMode === 'weekly') {
                // From 00:00 of the first day of the last week to 23:59 of the last one
                const now = new Date();
                const startOfWeek = new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay() - 6);
                startOfWeek.setHours(0, 0, 0);
                const endOfWeek = new Date(now.getFullYear(), now.getMonth(), startOfWeek.getDate() + 7);
                endOfWeek.setHours(23, 59, 59);
                const [ from, to ] = [ new Date(startOfWeek), new Date(endOfWeek) ];
                console.log([ from.toLocaleString(locale), to.toLocaleString(locale) ])
                return [ from.toLocaleString(locale), to.toLocaleString(locale) ];
            } else if (this.reportMode === 'monthly') {
                // From 00:00 of the first day of the last month to the last one
                const date = new Date(), y = date.getFullYear(), m = date.getMonth() - 1;
                const firstDay = new Date(y, m, 1);
                firstDay.setHours(0, 0, 0);
                const lastDay = new Date(y, m + 1, 0);
                lastDay.setHours(23, 59, 59);
                const [ from, to ] = [ new Date(firstDay), new Date(lastDay) ];
                return [ from.toLocaleString(locale), to.toLocaleString(locale) ];
            } else if (this.reportMode === 'cumulative') {
                // From 00:00 of the first day of the last month to the last one
                return [null, null];
            } else throw new Error('wrong report mode');
        },
        async updateData(clinic, apiKey, frecuency, cumulative) {
            this.loading = true;
            const [ from, to ] = this.calcDateRange();

            this.data = await DataAPI.getData({ clinic, apiKey, frecuency, cumulative, from, to }, true);
            this.clinic = this.data.clinic;

            this.loading = false;
        }
    },
    components: {
        ChatsStats, 
        ExistingVsNewOnes,
        ChatsPercentages, 
        TopQuestions, 
        TopLocations,
        ChatsByDevice,
        MostCommonlyQuestion,
    }
}
</script>

<style>
* { font-size: 1.003em; }

.v-card__title { word-break: break-word; }

.v-application { background-color: var(--v-background-base) !important; }

.dd-input fieldset {
    border-color: transparent;
    background-color: var(--v-ddblack-base);
}
</style>